'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jotai = require('jotai');
var reactQuery = require('react-query');

var queryClientAtom = jotai.atom(null);
var getQueryClient = function getQueryClient(get, set) {
  var queryClient = get(queryClientAtom);

  if (queryClient === null) {
    queryClient = new reactQuery.QueryClient();
    set(queryClientAtom, queryClient);
  }

  return queryClient;
};

function atomWithQuery(createQuery, equalityFn) {
  if (equalityFn === void 0) {
    equalityFn = Object.is;
  }

  var dataAtom = jotai.atom(new Promise(function () {}));
  var queryAtom = jotai.atom(function (get) {
    var options = typeof createQuery === 'function' ? createQuery(get) : createQuery;
    var initAtom = jotai.atom(null, function (get, set, cleanup) {
      set(dataAtom, new Promise(function () {}));
      var queryClient = getQueryClient(get, set);
      var observer = new reactQuery.QueryObserver(queryClient, options);
      var hasData = false;
      observer.subscribe(function (result) {
        if (result.data !== undefined) {
          if (!hasData || !equalityFn(get(dataAtom), result.data)) {
            hasData = true;
            set(dataAtom, result.data);
          }
        }
      });
      cleanup(function () {
        return observer.destroy();
      });
    });

    initAtom.onMount = function (init) {
      var destroy;

      var cleanup = function cleanup(callback) {
        if (destroy === false) {
          callback();
        } else {
          destroy = callback;
        }
      };

      init(cleanup);
      return function () {
        if (destroy) {
          destroy();
        }

        destroy = false;
      };
    };

    return [options, initAtom];
  }, function (get, set, action) {
    if (action.type === 'refetch') {
      var _queryClient$getQuery;

      var _get2 = get(queryAtom),
          options = _get2[0];

      set(dataAtom, new Promise(function () {}));
      var queryClient = getQueryClient(get, set);
      (_queryClient$getQuery = queryClient.getQueryCache().find(options.queryKey)) == null ? void 0 : _queryClient$getQuery.reset();
      var p = queryClient.refetchQueries(options.queryKey);
      return p;
    }

    return;
  });
  var queryDataAtom = jotai.atom(function (get) {
    var _get3 = get(queryAtom),
        initAtom = _get3[1];

    get(initAtom);
    return get(dataAtom);
  }, function (_get, set, action) {
    return set(queryAtom, action);
  });
  return queryDataAtom;
}

exports.atomWithQuery = atomWithQuery;
exports.queryClientAtom = queryClientAtom;
